var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchVertical(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2 4C10.4122 4 10.6157 4.08429 10.7657 4.23431L13.1657 6.63432C13.4781 6.94673 13.4781 7.45327 13.1657 7.76569C12.8533 8.07811 12.3467 8.07811 12.0343 7.76569L10.2 5.93137L8.36569 7.76569C8.05327 8.0781 7.54673 8.07811 7.23431 7.76569C6.9219 7.45327 6.9219 6.94673 7.23431 6.63431L9.63432 4.23431C9.78434 4.08429 9.98783 4 10.2 4ZM7.23431 11.4343C7.54673 11.1219 8.05327 11.1219 8.36569 11.4343L10.2 13.2686L12.0343 11.4343C12.3467 11.1219 12.8533 11.1219 13.1657 11.4343C13.4781 11.7467 13.4781 12.2533 13.1657 12.5657L10.7657 14.9657C10.4533 15.2781 9.94673 15.2781 9.63431 14.9657L7.23431 12.5657C6.9219 12.2533 6.9219 11.7467 7.23431 11.4343Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchVertical);
export default __webpack_public_path__ + "static/media/switch-vertical.030257bdf26729caf72a670c6d290542.svg";
export { ForwardRef as ReactComponent };